import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const accesToken = `Bearer ${localStorage.getItem("access")}`;
export const vendorService = createApi({
  reducerPath: "vendorService",
  tagTypes: ["customer"],
  baseQuery: fetchBaseQuery({ baseUrl: "https://api.upswap.app/api" }),
  endpoints: (builder) => ({
   deleteService: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (id) => ({
        url: `/appointments/delete-service/${id}/`,
        headers: {
          Authorization: accesToken,
        },
        method: "DELETE",
      }),
    }),
      getAllServices: builder.query({
      providesTags: ["vendor"],
      query: () => ({
        url: "/appointments/get-services/",
        headers: {
          Authorization: accesToken,
        },
        method: "GET",
      }),
    }),
     addVendorService: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (newPost) => ({
        url: "appointments/create-service/",
        headers: {
          Authorization: accesToken,
        },
        method: "POST",
        body: newPost,
      }),
    }),
     
     updateService: builder.mutation({
      invalidatesTags: ["vendor"],
      query: ({id, body}) => ({
        url: `appointments/update-service/${id}/`,
        headers: {
          Authorization: accesToken,
        },
        method: "PUT",
        body: body,
      }),
    }),
     getSingleService: builder.query({
      providesTags: ["vendor"],
      query: (id) => ({
        url: `/appointments/get-service/${id}/`,
        headers: {
          Authorization: accesToken,
        },
        method: "GET",
      }),
    }),
     getAllProviders: builder.query({
      providesTags: ["vendor"],
      query: () => ({
        url: "/appointments/get-providers/",
        headers: {
          Authorization: accesToken,
        },
        method: "GET",
      }),
    }),

    uploadImage: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (newPost) => ({
        url: "/UploadImagesAPI/",
        headers: {
          Authorization: accesToken,
        },
        method: "POST",
        body: newPost,
      }),
    }),
    getVendorLocation: builder.query({
      providesTags: ["vendor"],
      query: (id) => ({
        url: `vendor/addresses/?vendor_uuid=${id}/`,
        headers: {
          Authorization: accesToken,
        },
        method: "GET",
      }),
    }),
     addVendorDeal: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (newPost) => ({
        url: "/deals/create/",
        headers: {
          Authorization: accesToken,
        },
        method: "POST",
        body: newPost,
      }),
    }),

  }),
});

export const {
  useAddVendorServiceMutation,
  useDeleteServiceMutation,
  useGetAllServicesQuery,
  useGetAllProvidersQuery,
  useGetSingleServiceQuery,
  useUpdateServiceMutation,
  useUploadImageMutation,
  useGetVendorLocationQuery,
  useAddVendorDealMutation
} = vendorService;
export default vendorService;